import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import SelectPhone from  '../SelectPhone/SelectPhone';
import InputMask from 'react-input-mask';
import { FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import EmailFields from './EmailFields';
import AccountPasswordFields from './AccountPasswordFields';
import {isMobile} from 'react-device-detect';

class ContactFields extends Component {
  render() {
    return (
      <div>
        <EmailFields handleChange={this.props.handleChange} validateField={this.props.validateField} {...this.props} autoFocus={!isMobile} />
        {/* PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers */}
        <FormGroup>
          <Label for="mobilePhone">Mobile Phone</Label>
          <InputMask mask="999-999-9999" onChange={this.props.handleChange} onKeyDown={this.props.onKeyDown} onSelect={this.props.onClick} onClick={this.props.onClick} beforeMaskedValueChange={this.props.beforeMaskedValueChange} value={this.props.mobilePhone} onBlur={this.props.validateField} autoFocus={this.props.autoFocus}>
            {(inputProps) => <Input name="mobilePhone" {...inputProps} id="phone" type="tel" invalid={this.props.validation.mobilePhone.isInvalid} autoComplete="tel-national" autoCapitalize="off" autoCorrect="off" />}
          </InputMask>
          <FormFeedback>{this.props.validation.mobilePhone.message}</FormFeedback>   
        </FormGroup>
        <FormGroup>
          <Label for="homePhone">Home Phone</Label>
          <InputMask mask="999-999-9999" onChange={this.props.handleChange} onKeyDown={this.props.onKeyDown} onSelect={this.props.onClick} onClick={this.props.onClick} beforeMaskedValueChange={this.props.beforeMaskedValueChange} value={this.props.homePhone} onBlur={this.props.validateField} autoFocus={this.props.autoFocus}>
            {(inputProps) => <Input name="homePhone" {...inputProps} id="phone" type="tel" invalid={this.props.validation.homePhone.isInvalid} autoComplete="tel-national" autoCapitalize="off" autoCorrect="off" />}
          </InputMask>
          <FormFeedback>{this.props.validation.homePhone.message}</FormFeedback>
        </FormGroup>
        <AccountPasswordFields handleChange={this.props.handleChange} validateField={this.props.validateField} {...this.props} /> 
      </div>);
  }
}
ContactFields.defaultProps= {
  handleChange:() => {},
  // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
  validation: {
    mobilePhone: {
      isInvalid: false,
      message: ""
    },
    homePhone: {
      isInvalid: false,
      message: ""
    }
  },
  autoFocus: false
};

ContactFields.propTypes = {
  handleChange: PropTypes.func
};

export default ContactFields;


// WEBPACK FOOTER //
// ./src/components/Fields/ContactFields.js